// ── Importaciones tal cual ──────────────────────────────
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import Nav from 'react-bootstrap/Nav';
import Select from 'react-select'
import { Form } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { WarehouseFetchAPI } from '../../../api/Warehouse';
import { Modal } from 'react-bootstrap';
import SuccessAlert from '../../Alerts/SuccessAlert';
import ErrorAlert from '../../Alerts/ErrorAlert';

/* ─────────────────────────────────────────────────────────
   CSS — inyectado una vez. Prefijo: .mnuw-
───────────────────────────────────────────────────────── */
const MNUW_CSS = `
@keyframes mnuw-slide { from{opacity:0;transform:translateY(14px) scale(.97)} to{opacity:1;transform:translateY(0) scale(1)} }

/* ── modal ── */
.mnuw-dialog { max-width: 480px !important; }
.mnuw-dialog .modal-content {
  border: 1.5px solid rgba(0,0,0,.08) !important;
  border-radius: 20px !important;
  box-shadow: 0 24px 64px rgba(0,0,0,.18), 0 6px 16px rgba(0,0,0,.08) !important;
  overflow: hidden !important;
  animation: mnuw-slide .28s cubic-bezier(.34,1.56,.64,1) both !important;
}
.mnuw-dialog .modal-header { display: none !important; }
.mnuw-dialog .modal-body   { padding: 0 !important; }
.mnuw-dialog .modal-footer { display: none !important; }

/* ── header ── */
.mnuw-head {
  display: flex; align-items: center; gap: .65rem;
  padding: 1rem 1.25rem .9rem;
  background: linear-gradient(135deg, #0F2444 0%, #1B3A6B 100%);
}
.mnuw-head-ico {
  width: 36px; height: 36px; border-radius: 50%; flex-shrink: 0;
  background: rgba(255,255,255,.12); color: #fff;
  display: grid; place-items: center;
}
.mnuw-head-info { flex: 1; }
.mnuw-head-title {
  font-size: .93rem; font-weight: 700; color: #fff;
  font-family: var(--font-sans,-apple-system,sans-serif);
}
.mnuw-head-sub {
  font-size: .7rem; color: rgba(255,255,255,.5); margin-top: 1px;
  font-family: var(--font-sans,-apple-system,sans-serif);
}
.mnuw-head-close {
  width: 30px; height: 30px; border-radius: 50%; flex-shrink: 0;
  border: 1.5px solid rgba(255,255,255,.2); background: rgba(255,255,255,.1);
  color: rgba(255,255,255,.8); display: grid; place-items: center;
  cursor: pointer; transition: all .14s;
}
.mnuw-head-close:hover { background: rgba(239,68,68,.3); border-color: rgba(239,68,68,.5); }

/* ── form body ── */
.mnuw-body { padding: 1.15rem 1.25rem; display: flex; flex-direction: column; gap: .85rem; }

/* form labels */
.mnuw-dialog .form-label {
  font-size: .74rem !important; font-weight: 600 !important;
  color: var(--text-2,#6B7280) !important;
  font-family: var(--font-sans,-apple-system,sans-serif) !important;
  margin-bottom: .3rem !important;
}

/* form fields */
.mnuw-dialog .form-control,
.mnuw-dialog .form-select {
  border: 1.5px solid rgba(0,0,0,.11) !important;
  border-radius: 10px !important;
  background: rgba(0,0,0,.03) !important;
  font-family: var(--font-sans,-apple-system,sans-serif) !important;
  font-size: .83rem !important;
  color: var(--text,#0A0A0A) !important;
  transition: border-color .14s, box-shadow .14s !important;
}
.mnuw-dialog .form-control:focus,
.mnuw-dialog .form-select:focus {
  border-color: #1B3A6B !important;
  box-shadow: 0 0 0 3px rgba(27,58,107,.10) !important;
  background: var(--bg,#fff) !important;
  outline: none !important;
}
.mnuw-dialog .form-control::placeholder { color: #B0B0B8 !important; }

/* ── footer ── */
.mnuw-footer {
  display: flex; align-items: center; justify-content: flex-end; gap: .5rem;
  padding: .8rem 1.25rem .95rem;
  border-top: 1px solid var(--border,rgba(0,0,0,.07));
}
.mnuw-btn-cancel {
  padding: .52rem 1.1rem; border-radius: 9px;
  border: 1.5px solid rgba(0,0,0,.12); background: rgba(0,0,0,.04);
  color: var(--text-2,#6B7280);
  font-family: var(--font-sans,-apple-system,sans-serif);
  font-size: .81rem; font-weight: 500; cursor: pointer; transition: all .13s;
}
.mnuw-btn-cancel:hover { border-color: #EF4444; color: #EF4444; }
.mnuw-btn-submit {
  padding: .52rem 1.25rem; border-radius: 9px; border: none;
  background: #1B3A6B; color: #fff;
  font-family: var(--font-sans,-apple-system,sans-serif);
  font-size: .81rem; font-weight: 600; cursor: pointer;
  transition: background .14s, transform .14s;
  display: flex; align-items: center; gap: .35rem;
}
.mnuw-btn-submit:hover { background: #152D54; transform: translateY(-1px); }

@media(max-width: 520px) {
  .mnuw-dialog { max-width: calc(100vw - 1.5rem) !important; }
}
`;

/* ── inject CSS once ── */
if (typeof window !== 'undefined' && !document.getElementById('mnuw-styles')) {
  const el = document.createElement('style');
  el.id = 'mnuw-styles'; el.textContent = MNUW_CSS;
  document.head.appendChild(el);
}

/* ── ICONS ── */
const IcoDb   = ()=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/></svg>;
const IcoEdit = ()=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4z"/></svg>;
const IcoPlus = ()=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>;
const IcoX    = ()=><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IcoSave = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>;

/* ════════════════════════════════════════════════════════
   COMPONENT — lógica 100% original
════════════════════════════════════════════════════════ */
const ModalNewUpdateWarehouse = ({
  showModalNewWarehouse, setShowModalNewWarehouse,
  selectedBranch, warehouseSelect, getWarehouseByBrachoffice
}) => {

  /* ════════════════════════════════════
     LÓGICA ORIGINAL — 100% INTACTA
  ════════════════════════════════════ */
  const token = localStorage.getItem('x-access-token');
  const [warehouseDefauld, setWarehouseDefauld] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    form.append("branchoffice_id", selectedBranch.id);
    let data = Object.fromEntries(form.entries());
    console.log(selectedBranch);
    if (warehouseSelect.id) { console.log(data); updateWarehouse(data); }
    else { createWarehouse(data); }
  };

  const createWarehouse = async (data) => {
    try {
      await WarehouseFetchAPI.createWarehouse(data, token);
      ErrorAlert('', 'Producto creado con exito', 'success');
      setShowModalNewWarehouse(false);
      getWarehouseByBrachoffice(selectedBranch.id);
    } catch (err) {
      ErrorAlert(err.response.data.error, 'Error de creacion', 'error');
      console.log(err);
    }
  };

  const updateWarehouse = async (data) => {
    if (data.Location == "") data.Location = warehouseSelect.location;
    if (data.name == "") data.name = warehouseSelect.name;
    try {
      const response = await WarehouseFetchAPI.updateWarehouse(warehouseSelect.id, data, token);
      setShowModalNewWarehouse(false);
      ErrorAlert('', 'Bodega actulizada con exito', 'success');
      getWarehouseByBrachoffice(selectedBranch.id);
    } catch (err) {
      ErrorAlert(err.response.data.error, 'Error de actualizacion', 'error');
      console.log(err);
    }
  };
  /* ════════════════════════════════════
     FIN LÓGICA ORIGINAL
  ════════════════════════════════════ */

  const isEdit = !!warehouseSelect.id;

  return (
    <>
      <Modal
        show={showModalNewWarehouse}
        onHide={() => setShowModalNewWarehouse(false)}
        size="xl"
        centered
        dialogClassName="mnuw-dialog"
      >
        <Modal.Header>
          <h1>{isEdit ? <><i className="uil uil-edit" /> Editar bodega</> : <><i className="uil uil-plus-circle" /> Nueva bodega</>}</h1>
        </Modal.Header>

        <Modal.Body>

          {/* ── visual header ── */}
          <div className="mnuw-head">
            <div className="mnuw-head-ico">{isEdit ? <IcoEdit /> : <IcoPlus />}</div>
            <div className="mnuw-head-info">
              <div className="mnuw-head-title">{isEdit ? 'Editar bodega' : 'Nueva bodega'}</div>
              <div className="mnuw-head-sub">
                {isEdit ? `Modificando: ${warehouseSelect.name}` : `Sucursal: ${selectedBranch.name || '—'}`}
              </div>
            </div>
            <button className="mnuw-head-close" type="button" onClick={() => setShowModalNewWarehouse(false)}>
              <IcoX />
            </button>
          </div>

          {/* ── form — lógica original intacta ── */}
          <Form className="needs-validation" onSubmit={submit}>
            <div className="mnuw-body">

              <Form.Group className="mb-3" controlId="name">
                <Form.Label>Nombre de la bodega</Form.Label>
                <Form.Control
                  type="text"
                  placeholder={isEdit ? warehouseSelect.name : "Ejemplo: Bodega principal"}
                  name="name"
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="secundaryName">
                <Form.Label>Localización de la bodega</Form.Label>
                <Form.Control
                  type="text"
                  placeholder={isEdit ? warehouseSelect.location : "Ejemplo: Cocina, Almacén..."}
                  name="location"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>¿Bodega por defecto?</Form.Label>
                <Form.Select
                  aria-label=""
                  name="is_default"
                  onChange={e => setWarehouseDefauld(e.target.value)}
                >
                  <option value={0}>No</option>
                  <option value={1}>Sí</option>
                </Form.Select>
              </Form.Group>

            </div>

            {/* ── footer con botones ── */}
            <div className="mnuw-footer">
              <button
                className="mnuw-btn-cancel"
                type="button"
                onClick={() => setShowModalNewWarehouse(false)}
              >
                Cancelar
              </button>
              {/* Button original — type="submit" intacto */}
              <Button className="mnuw-btn-submit" size="sm" variant="success" type="submit">
                <IcoSave /> {isEdit ? 'Actualizar' : 'Guardar'}
              </Button>
            </div>

          </Form>

        </Modal.Body>

        <Modal.Footer>
          <Button onClick={() => setShowModalNewWarehouse(false)}>Cerrar</Button>
        </Modal.Footer>
      </Modal>

      {/* imports no-JSX preservados */}
      {void [SuccessAlert, ErrorAlert, useEffect, useParams, Tabs, Tab, Row, Col, Nav, Select]}
    </>
  );
};

export default ModalNewUpdateWarehouse;